export function slugify(url) {
    return url.toLowerCase().replace(/[\s]/g, '-').trim();
}